import { Button } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';
import CountDownFinal from './CountDownFinal';

const navItems = [
  { name: 'Trang chủ', href: 'https://www.78winl.xyz/' },
  { name: 'Dự đoán', href: '/' },
  { name: 'Thể lệ', href: '/rule' },
  { name: 'Kết quả', href: '/prize-structure' }
];

const Header = () => {
  // const location = useLocation();
  // const activeNav = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  // const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.OK9
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          navItems[0].href = settingsMap.link_home || '#';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full relative">
      <div className="absolute top-4 right-0 hidden md:flex z-10 flex-row gap-2">
        <Button
          className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-black"
          onClick={() => window.open(settings.link_home, '_blank', 'noopener,noreferrer')}
          style={{
            background: 'black',
            color: 'white'
          }}
        >
          TRANG CHỦ
        </Button>
        <Button
          className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-black"
          onClick={() => window.open(settings.link_register, '_blank', 'noopener,noreferrer')}
          style={{
            background: 'black',
            color: 'white'
          }}
        >
          ĐĂNG KÝ
        </Button>
      </div>
      <div
        className="w-full max-w-[1280px] mx-auto rounded-b-[25px]
            flex flex-row items-center justify-center
            py-1 md:pt-3
            px-2 md:px-3 lg:px-6"
      >
        <div className="flex flex-col py-3 items-center justify-center  mx-auto">
          <Link to={settings.link_home || '#'}>
            <img
              src="/assets/images/header/logo_small.png"
              alt="Logo 78Win"
              className="hidden md:flex w-full h-auto object-contain mx-auto"
            />
            <img
              src="/assets/images/header/logo.png"
              alt="Logo 78Win"
              className="flex md:hidden w-full max-w-[80%] items-center justify-center h-auto object-contain mx-auto"
            />
          </Link>
          <img
            src="/assets/images/header/header_pc.png"
            alt="Logo 78Win"
            className="hidden md:flex w-full h-auto object-contain"
          />
          <img
            src="/assets/images/header/header_mb_2.png"
            alt="Linh vat 78Win"
            className="flex md:hidden w-full mt-2 h-auto object-contain"
          />
          <div className="relative bottom-5 md:bottom-32 md:ml-6">
            <CountDownFinal />
          </div>
          <div className="relative bottom-2 flex flex-row md:hidden gap-2 md:py-2">
            <Button
              // type="primary"
              className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-black"
              onClick={() => window.open(settings.link_home, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'black',
                color: 'white'
              }}
            >
              TRANG CHỦ
            </Button>
            <Button
              // type="primary"
              className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-black"
              onClick={() => window.open(settings.link_register, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'black',
                color: 'white'
              }}
            >
              ĐĂNG KÝ
            </Button>
          </div>
        </div>
      </div>
      {/* <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      /> */}
    </div>
  );
};

export default Header;
